var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay-root"},_vm._l((_vm.overlays),function(value,key){return _c('ui-overlay',{key:key,attrs:{"id":key}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }